(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["category-stories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pun-category-stories')) {
  customElements.define('pun-category-stories', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.pun-stories__track');
      this.dialog = this.querySelector('dialog');
      this.host = this.querySelector('[data-video-host]');
      this.videoItems = [...this.querySelectorAll('[data-story-item]')].filter(item => item.querySelector('template'));
      this.rowPaused = false;
      this.muted = false;
      this.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.contains(button)) return;
        if (button.hasAttribute('data-open-story')) this.open(this.videoItems.indexOf(button.closest('[data-story-item]')));
        if (button.hasAttribute('data-row-prev')) this.moveRow(-1);
        if (button.hasAttribute('data-row-next')) this.moveRow(1);
        if (button.hasAttribute('data-row-pause')) {
          this.rowPaused = !this.rowPaused;
          button.textContent = this.rowPaused ? 'Play category slider' : 'Pause category slider';
        }
        if (button.hasAttribute('data-close')) this.dialog.close();
        if (button.hasAttribute('data-story-prev')) this.changeStory(-1);
        if (button.hasAttribute('data-story-next')) this.changeStory(1);
        if (button.hasAttribute('data-mute') && this.video) this.video.muted = !this.video.muted;
        if (button.hasAttribute('data-retry') && this.video) {
          this.querySelector('[data-video-error]').hidden = true; this.video.load(); this.playVideo();
        }
      }, {signal});
      this.dialog.addEventListener('close', () => this.cleanupVideo(), {signal});
      this.dialog.addEventListener('click', event => { if(event.target === this.dialog) this.dialog.close(); }, {signal});
      this.dialog.addEventListener('keydown', event => {
        if (event.target.tagName === 'VIDEO') return;
        if (event.key === 'ArrowRight') {event.preventDefault();this.changeStory(1);}
        if (event.key === 'ArrowLeft') {event.preventDefault();this.changeStory(-1);}
      }, {signal});
      const stage=this.querySelector('[data-stage]');
      stage.addEventListener('pointerdown', event => {
        const box=stage.getBoundingClientRect();
        this.swipe = event.clientY < box.bottom-55 ? {x:event.clientX,y:event.clientY} : null;
      }, {signal});
      stage.addEventListener('pointerup', event => {
        if (!this.swipe) return;
        const dx=event.clientX-this.swipe.x,dy=event.clientY-this.swipe.y;this.swipe=null;
        if(Math.abs(dx)>65&&Math.abs(dx)>Math.abs(dy)*1.5)this.changeStory(dx<0?1:-1);
      }, {signal});
      document.addEventListener('visibilitychange',()=>{if(document.hidden&&this.video)this.video.pause();},{signal});
      this.addEventListener('shopify:block:select', event=>{
        const item=event.target.closest('[data-story-item]');
        if(item){this.rowPaused=true;const pause=this.querySelector('[data-row-pause]');if(pause)pause.textContent='Play category slider';item.scrollIntoView({block:'nearest',inline:'center',behavior:'auto'});}
      },{signal});
      this.observer=new ResizeObserver(()=>this.refreshRow());this.observer.observe(this.track);this.refreshRow();
      if(this.dataset.autoplay==='true')this.timer=setInterval(()=>{
        if(!this.dialog.open&&!this.rowPaused&&!document.hidden&&!this.matches(':hover')&&!this.contains(document.activeElement)&&!matchMedia('(prefers-reduced-motion: reduce)').matches)this.moveRow(1);
      },Math.max(2500,Number(this.dataset.speed)||3500));
    }
    refreshRow() {
      const overflow=this.track.scrollWidth>this.track.clientWidth+3;
      this.querySelectorAll('[data-row-prev],[data-row-next],[data-row-pause]').forEach(button=>button.hidden=!overflow);
    }
    moveRow(direction) {
      if(!this.track.firstElementChild)return;
      const step=this.track.firstElementChild.getBoundingClientRect().width+parseFloat(getComputedStyle(this.track).columnGap||0);
      const max=this.track.scrollWidth-this.track.clientWidth;
      let left=this.track.scrollLeft+direction*step;
      if(direction>0&&this.track.scrollLeft>=max-3)left=0;
      if(direction<0&&this.track.scrollLeft<=3)left=max;
      this.track.scrollTo({left:Math.max(0,Math.min(max,left)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    }
    open(index) {
      if(index<0)return;
      if(!this.dialog.open){this.previousOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();}
      this.loadStory(index);
      this.querySelector('[data-close]').focus();
    }
    loadStory(index) {
      if(this.video){this.video.pause();this.videoAbort?.abort();}
      this.index=index;
      const item=this.videoItems[index];
      this.host.replaceChildren(item.querySelector('template').content.cloneNode(true));
      this.video=this.host.querySelector('video');
      this.querySelector('[data-video-title]').textContent=item.dataset.title;
      const shop=this.querySelector('[data-shop]');
      this.querySelector('[data-shop-wrap]').hidden=!item.dataset.link;
      if(item.dataset.link)shop.href=item.dataset.link;else shop.removeAttribute('href');
      this.querySelector('[data-progress]').style.width='0%';
      this.querySelector('[data-video-error]').hidden=true;
      this.querySelector('[data-story-prev]').hidden=index===0;
      this.querySelector('[data-story-next]').hidden=index>=this.videoItems.length-1;
      if(!this.video)return;
      this.videoAbort=new AbortController();const signal=this.videoAbort.signal;
      this.video.muted=this.muted;
      this.updateMute();
      this.video.addEventListener('volumechange',()=>{this.muted=this.video.muted;this.updateMute();},{signal});
      this.video.addEventListener('timeupdate',()=>{
        if(Number.isFinite(this.video.duration)&&this.video.duration>0)this.querySelector('[data-progress]').style.width=Math.min(100,this.video.currentTime/this.video.duration*100)+'%';
      },{signal});
      this.video.addEventListener('ended',()=>{
        if(this.dataset.nextStory==='true'){
          if(this.index<this.videoItems.length-1)this.changeStory(1);else this.dialog.close();
        }
      },{signal});
      this.video.addEventListener('error',()=>this.querySelector('[data-video-error]').hidden=false,{signal});
      this.playVideo();
    }
    async playVideo() {
      const video=this.video;
      try{await video.play();}catch{
        if(this.video!==video||!this.dialog.open)return;
        video.muted=true;this.muted=true;this.updateMute();
        try{await video.play();}catch{/* Native play controls remain available. */}
      }
    }
    updateMute() {
      const button=this.querySelector('[data-mute]');
      button.textContent=this.video?.muted?'Sound on':'Mute';
      button.setAttribute('aria-label',this.video?.muted?'Unmute video':'Mute video');
    }
    changeStory(direction) {
      const next=this.index+direction;
      if(next>=0&&next<this.videoItems.length)this.loadStory(next);
    }
    cleanupVideo() {
      this.video?.pause();this.videoAbort?.abort();this.host.replaceChildren();this.video=null;
      if(this.previousOverflow!==undefined){document.body.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}
    }
    disconnectedCallback() {
      clearInterval(this.timer);this.observer?.disconnect();
      if(this.dialog?.open)this.dialog.close();
      this.cleanupVideo();this.abort?.abort();this.initialized=false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["watch-and-shop"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('pun-watch-shop')) return;
  class PunWatchShop extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.track = this.querySelector('.pun-watch__track');
      this.cards = [...this.querySelectorAll('.pun-watch__card')];
      this.nav = this.querySelector('.pun-watch__nav');
      this.status = this.querySelector('.pun-watch__status');
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.hover = false; this.userPaused = false; this.active = null;
      this.endpoint = this.getEndpoint();
      this.cardData = new Map();
      this.cards.forEach(card => {
        const button = card.querySelector('.pun-watch__play');
        if (button) button.addEventListener('click', () => this.play(card), { signal });
        if (this.endpoint && card.dataset.videoId) this.loadCount(card);
      });
      this.querySelectorAll('[data-direction]').forEach(button => {
        button.addEventListener('click', () => this.move(Number(button.dataset.direction)), { signal });
      });
      const auto = this.querySelector('.pun-watch__auto');
      if (auto) auto.addEventListener('click', () => {
        this.userPaused = !this.userPaused;
        auto.setAttribute('aria-pressed', String(this.userPaused));
        auto.textContent = this.userPaused ? 'Resume sliding' : 'Pause sliding';
      }, { signal });
      this.addEventListener('pointerenter', () => { this.hover = true; }, { signal });
      this.addEventListener('pointerleave', () => { this.hover = false; }, { signal });
      this.track.addEventListener('scroll', () => this.updateNav(), { signal, passive: true });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
      }, { signal });
      document.addEventListener('pun-watch-playing', event => {
        if (event.detail !== this) this.pause();
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const card = this.cards.find(item => item.dataset.blockId === event.detail?.blockId);
        if (card) { this.userPaused = true; this.track.scrollLeft = card.offsetLeft - this.cards[0].offsetLeft; }
      }, { signal });
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) this.cardData.get(entry.target)?.video.pause();
        });
      }, { threshold: 0.5 });
      this.cards.forEach(card => this.observer.observe(card));
      this.resize = new ResizeObserver(() => this.updateNav());
      this.resize.observe(this.track);
      this.timer = setInterval(() => {
        const playing = this.active && !this.active.paused && !this.active.ended;
        if (this.dataset.auto !== 'true' || this.dataset.designMode === 'true' || this.reduced.matches || this.userPaused || this.hover || document.hidden || this.contains(document.activeElement) || playing) return;
        const bounds = this.getBoundingClientRect();
        if (bounds.bottom <= 0 || bounds.top >= innerHeight) return;
        this.move(1, true);
      }, Number(this.dataset.interval) || 5000);
      this.updateNav();
    }
    disconnectedCallback() {
      this.pause(); clearInterval(this.timer); this.observer?.disconnect(); this.resize?.disconnect();
      this.abort?.abort(); this.abort = null;
      this.querySelectorAll('.pun-watch__player').forEach(host => host.replaceChildren());
      this.querySelectorAll('.pun-watch__play').forEach(button => { button.hidden = false; });
    }
    pause() { if (this.active) this.active.pause(); }
    move(direction, wrap = false) {
      const step = this.cards[1] ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : this.track.clientWidth;
      const end = this.track.scrollWidth - this.track.clientWidth;
      let left = this.track.scrollLeft + direction * step;
      if (wrap && left > end + 2) left = 0;
      this.track.scrollTo({ left: Math.max(0, Math.min(left, end)), behavior: this.reduced.matches ? 'auto' : 'smooth' });
    }
    updateNav() {
      const end = this.track.scrollWidth - this.track.clientWidth;
      this.nav.hidden = end < 3;
      this.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 2;
      this.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft >= end - 2;
    }
    play(card) {
      let data = this.cardData.get(card);
      if (!data) {
        const host = card.querySelector('.pun-watch__player');
        host.append(card.querySelector('template').content.cloneNode(true));
        const video = host.querySelector('video');
        if (!video) return;
        video.muted = false;
        data = { video, watched: 0, lastTime: 0, lastWall: 0, sent: false, pending: false };
        this.cardData.set(card, data);
        const signal = this.abort.signal;
        video.addEventListener('play', () => {
          this.cardData.forEach(other => { if (other.video !== video) other.video.pause(); });
          this.active = video;
          data.lastTime = video.currentTime; data.lastWall = performance.now();
          document.dispatchEvent(new CustomEvent('pun-watch-playing', { detail: this }));
          this.dispatchEvent(new CustomEvent('pun:video-play', { bubbles: true, detail: { videoId: card.dataset.videoId } }));
        }, { signal });
        video.addEventListener('timeupdate', () => {
          const now = performance.now();
          const delta = video.currentTime - data.lastTime;
          const wall = (now - data.lastWall) / 1000;
          if (!video.paused && !video.seeking && !document.hidden && delta > 0 && delta < 2 && wall > 0 && wall < 2) {
            data.watched += Math.min(delta, wall);
          }
          data.lastTime = video.currentTime; data.lastWall = now;
          if (data.watched >= 3) this.recordCount(card, data);
        }, { signal });
        video.addEventListener('seeked', () => { data.lastTime = video.currentTime; data.lastWall = performance.now(); }, { signal });
        video.addEventListener('error', () => {
          this.status.textContent = 'This video could not be loaded. Please try again.'; this.status.hidden = false;
          card.querySelector('.pun-watch__play').hidden = false;
        }, { signal });
      }
      if (data.video.ended) data.video.currentTime = 0;
      card.querySelector('.pun-watch__play').hidden = true;
      data.video.play().catch(() => { card.querySelector('.pun-watch__play').hidden = false; });
    }
    getEndpoint() {
      if (this.dataset.countEnabled !== 'true' || this.dataset.designMode === 'true') return null;
      const raw = (this.dataset.counterPath || '').trim();
      if (!raw) return null;
      try {
        const url = new URL(raw, location.origin);
        if (url.origin !== location.origin || !url.pathname.startsWith('/apps/') || url.search || url.hash) return null;
        return url;
      } catch (_) { return null; }
    }
    async request(url, options = {}) {
      const controller = new AbortController();
      const abort = () => controller.abort();
      this.abort.signal.addEventListener('abort', abort, { once: true });
      const timeout = setTimeout(abort, 6000);
      try {
        const response = await fetch(url, { ...options, signal: controller.signal, credentials: 'same-origin', cache: 'no-store' });
        if (!response.ok) throw new Error('Counter unavailable');
        return await response.json();
      } finally { clearTimeout(timeout); this.abort?.signal.removeEventListener('abort', abort); }
    }
    showCount(card, plays) {
      if (typeof plays !== 'number' || !Number.isSafeInteger(plays) || plays < 0 || !this.isConnected) return;
      const badge = card.querySelector('.pun-watch__count');
      if (!badge) return;
      const previous = Number(card.dataset.plays || 0);
      const total = Math.max(previous, plays);
      card.dataset.plays = String(total);
      badge.textContent = `${this.dataset.countLabel || 'Website plays'}: ${new Intl.NumberFormat('en-IN').format(total)}`;
      badge.hidden = false;
    }
    async loadCount(card) {
      try {
        const url = new URL(this.endpoint); url.searchParams.set('video_id', card.dataset.videoId);
        const result = await this.request(url);
        this.showCount(card, result.plays);
      } catch (_) { /* Keep counts hidden when service is unavailable. */ }
    }
    async recordCount(card, data) {
      if (!this.endpoint || data.sent || data.pending) return;
      const key = `pun-watch-counted:${card.dataset.videoId}`;
      try { if (sessionStorage.getItem(key)) { data.sent = true; return; } } catch (_) {}
      data.pending = true;
      data.eventId ||= globalThis.crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      try {
        const result = await this.request(this.endpoint, {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ video_id: card.dataset.videoId, event_id: data.eventId })
        });
        if (typeof result.plays !== 'number' || !Number.isSafeInteger(result.plays) || result.plays < 0) throw new Error('Invalid count');
        data.sent = true; this.showCount(card, result.plays);
        try { sessionStorage.setItem(key, '1'); } catch (_) {}
      } catch (_) { data.sent = true; /* No fabricated count or repeated failed requests. */ }
      finally { data.pending = false; }
    }
  }
  customElements.define('pun-watch-shop', PunWatchShop);
})();

  } catch(e) { console.error(e); }
})();
})();
